export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-20">
      <div className="label-eyebrow">Legal</div>
      <h1 className="wordmark mt-4 text-5xl md:text-6xl uppercase">Terms Of Service.</h1>
      <p className="mt-8 text-foreground/80">BA30 is an educational fitness program. Consult a doctor before starting any new fitness regimen. Refunds available within 14 days of purchase.</p>
    </div>
  );
}
